unit Unit1;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids,  WEBLib.Controls,
  WEBLib.ExtCtrls, WEBLib.CDS, Vcl.Graphics, WEBLib.Buttons,
  Vcl.Imaging.pngimage, Vcl.Imaging.jpeg;
type
  TForm1 = class(TForm)
    WebLabel26: TLabel;
    WebLabel7: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel16: TLabel;
    WebLabel21: TLabel;
    WebComboBox4: TComboBox;
    WebComboBox3: TComboBox;
    WebComboBox2: TComboBox;
    WebComboBox1: TComboBox;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    Transport: TImageControl;
    WebCheckBox1: TCheckBox;
    WebCheckBox2: TCheckBox;
    WebCheckBox4: TCheckBox;
    WebCheckBox6: TCheckBox;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebLabel4: TLabel;
    Opis: TImageControl;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    procedure WebComboBox1Click(Sender: TObject);
    procedure WebComboBox2Click(Sender: TObject);
    procedure WebComboBox3Click(Sender: TObject);
    procedure WebComboBox4Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

uses  uFrmMain;

procedure TForm1.WebComboBox1Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox1.ItemIndex;
ILO_P:=StrtoFloat(WebEdit6.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
TRA:=StrtoFloat(FrmMain.WebEdit2.Text);
PO:=WebComboBox1.ItemIndex;
case PO of
0: ILO:=7.82;
1: ILO:=4.3;
2: ILO:=2.2;
3: ILO:=0.68;
4: ILO:=0.39;
5: ILO:=0;
end;
TRA:=TRA+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox1.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox1.Checked=true then TRA:=TRA-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit2.Text:=FloattoStr(TRA);
WebEdit6.Text:=FloattoStr(ILO);
WebCheckBox1.Checked:=true;
WebComboBox1.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit12.Text:='1';
end;

procedure TForm1.WebComboBox2Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox2.ItemIndex;
ILO_P:=StrtoFloat(WebEdit7.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
TRA:=StrtoFloat(FrmMain.WebEdit2.Text);
PO:=WebComboBox2.ItemIndex;
case PO of
0: ILO:=0;
1: ILO:=-0.46;
2: ILO:=-1.87;
end;
TRA:=TRA+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox2.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox2.Checked=true then TRA:=TRA-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit2.Text:=FloattoStr(TRA);
WebEdit7.Text:=FloattoStr(ILO);
WebCheckBox2.Checked:=true;
WebComboBox2.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit12.Text:='1';
end;

procedure TForm1.WebComboBox3Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox3.ItemIndex;
ILO_P:=StrtoFloat(WebEdit12.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
TRA:=StrtoFloat(FrmMain.WebEdit2.Text);
PO:=WebComboBox3.ItemIndex;
case PO of
0: ILO:=1.26;
1: ILO:=0.85;
2: ILO:=0.03;
3: ILO:=-0.59;
4: ILO:=-0.79;
5: ILO:=0.44;
end;
TRA:=TRA+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox4.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox4.Checked=true then TRA:=TRA-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit2.Text:=FloattoStr(TRA);
WebEdit12.Text:=FloattoStr(ILO);
WebCheckBox4.Checked:=true;
WebComboBox3.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit12.Text:='1';
end;

procedure TForm1.WebComboBox4Click(Sender: TObject);
var   ILO, ILO_P   : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox4.ItemIndex;
ILO_P:=StrtoFloat(WebEdit13.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
TRA:=StrtoFloat(FrmMain.WebEdit2.Text);
PO:=WebComboBox4.ItemIndex;
case PO of
0: ILO:=4.47;
1: ILO:=2.68;
2: ILO:=1.67;
3: ILO:=0.89;
4: ILO:=0.39;
5: ILO:=0.17;
6: ILO:=0;
end;
TRA:=TRA+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox6.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox6.Checked=true then TRA:=TRA-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit2.Text:=FloattoStr(TRA);
WebEdit13.Text:=FloattoStr(ILO);
WebCheckBox6.Checked:=true;
WebComboBox4.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox4.Checked=true then TAK:=Tak+1;
if WebCheckBox6.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit12.Text:='1';
end;
procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel26 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  Transport := TImageControl.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebCheckBox6 := TCheckBox.Create(Self);
  WebCheckBox4 := TCheckBox.Create(Self);
  WebCheckBox2 := TCheckBox.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);

  WebLabel26.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  Transport.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebCheckBox6.BeforeLoadDFMValues;
  WebCheckBox4.BeforeLoadDFMValues;
  WebCheckBox2.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 703;
    Height := 464;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 59;
    WebLabel26.Width := 73;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Transport';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 439;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 9;
    WebLabel13.Top := 88;
    WebLabel13.Width := 216;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Ile kilometr'#243'w pokonujesz rocznie prywatnie?';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 9;
    WebLabel14.Top := 132;
    WebLabel14.Width := 284;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Na jakim paliwie je'#378'dzi samoch'#243'd, kt'#243'rego zwykle u'#380'ywasz?';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 9;
    WebLabel16.Top := 166;
    WebLabel16.Width := 264;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Jakie jest rzeczywiste zu'#380'ycie paliwa przez samoch'#243'd,?';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 9;
    WebLabel21.Top := 207;
    WebLabel21.Width := 289;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Ile kilometr'#243'w pokonujesz tygodniowo komunikacj'#261' miejsk'#261' ?';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 9;
    WebLabel1.Top := 102;
    WebLabel1.Width := 295;
    WebLabel1.Height := 13;
    WebLabel1.Caption := '(samochodem lub motocyklem jako kierowca lub jako pasa'#380'er)';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 179;
    WebLabel2.Width := 290;
    WebLabel2.Height := 13;
    WebLabel2.Caption := '(kt'#243'ry zazwyczaj u'#380'ywasz do cel'#243'w prywatnych, na 100 km)';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 8;
    WebLabel3.Top := 218;
    WebLabel3.Width := 291;
    WebLabel3.Height := 13;
    WebLabel3.Caption := '(poci'#261'g, autobus, tramwaj, metro, bez podr'#243#380'y s'#322'u'#380'bowych)';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    Transport.SetParentComponent(Self);
    Transport.Name := 'Transport';
    Transport.Left := 376;
    Transport.Top := 274;
    Transport.Width := 312;
    Transport.Height := 162;
    Transport.HeightPercent := 100.000000000000000000;
    Transport.WidthPercent := 100.000000000000000000;
    Transport.ChildOrder := 20;
    Transport.Picture.LoadFromFile('Unit1.Transport.Picture.jpg');
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 2;
    WebLabel4.Top := 330;
    WebLabel4.Width := 188;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Prosz'#281' odpowiedzie'#263' na ka'#380'de pytanie.';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clBlue;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    Opis.SetParentComponent(Self);
    Opis.Name := 'Opis';
    Opis.Left := 103;
    Opis.Top := 349;
    Opis.Width := 137;
    Opis.Height := 57;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 3;
    Opis.Picture.LoadFromFile('Unit1.Opis.Picture.png');
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 2;
    WebLabel5.Top := 411;
    WebLabel5.Width := 246;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Zielone pod'#347'wietlenie oznacza udzielon'#261' odpowied'#378;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clBlue;
    WebLabel5.Font.Height := -11;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 538;
    WebLabel6.Top := 439;
    WebLabel6.Width := 150;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clBlue;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebCheckBox6.SetParentComponent(Self);
    WebCheckBox6.Name := 'WebCheckBox6';
    WebCheckBox6.Left := 325;
    WebCheckBox6.Top := 209;
    WebCheckBox6.Width := 113;
    WebCheckBox6.Height := 22;
    WebCheckBox6.ChildOrder := 21;
    WebCheckBox6.Color := clNone;
    WebCheckBox6.HeightPercent := 100.000000000000000000;
    WebCheckBox6.State := cbUnchecked;
    WebCheckBox6.Visible := False;
    WebCheckBox6.WidthPercent := 100.000000000000000000;
    WebCheckBox4.SetParentComponent(Self);
    WebCheckBox4.Name := 'WebCheckBox4';
    WebCheckBox4.Left := 325;
    WebCheckBox4.Top := 168;
    WebCheckBox4.Width := 113;
    WebCheckBox4.Height := 22;
    WebCheckBox4.ChildOrder := 21;
    WebCheckBox4.Color := clNone;
    WebCheckBox4.HeightPercent := 100.000000000000000000;
    WebCheckBox4.State := cbUnchecked;
    WebCheckBox4.Visible := False;
    WebCheckBox4.WidthPercent := 100.000000000000000000;
    WebCheckBox2.SetParentComponent(Self);
    WebCheckBox2.Name := 'WebCheckBox2';
    WebCheckBox2.Left := 325;
    WebCheckBox2.Top := 129;
    WebCheckBox2.Width := 113;
    WebCheckBox2.Height := 22;
    WebCheckBox2.ChildOrder := 21;
    WebCheckBox2.Color := clNone;
    WebCheckBox2.HeightPercent := 100.000000000000000000;
    WebCheckBox2.State := cbUnchecked;
    WebCheckBox2.Visible := False;
    WebCheckBox2.WidthPercent := 100.000000000000000000;
    WebCheckBox1.SetParentComponent(Self);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 325;
    WebCheckBox1.Top := 92;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.ChildOrder := 21;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.Visible := False;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebComboBox4.SetParentComponent(Self);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 341;
    WebComboBox4.Top := 209;
    WebComboBox4.Width := 347;
    WebComboBox4.Height := 21;
    WebComboBox4.HeightPercent := 100.000000000000000000;
    WebComboBox4.Text := 'Ponad 600 kim';
    WebComboBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox4, Self, 'OnClick', 'WebComboBox4Click');
    WebComboBox4.ItemIndex := 0;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('Ponad 600 kim');
      WebComboBox4.Items.Add('360 - 600 kim');
      WebComboBox4.Items.Add('240 - 360 kim');
      WebComboBox4.Items.Add('80 - 240 kim');
      WebComboBox4.Items.Add('60 - 80 kim');
      WebComboBox4.Items.Add('Mniej ni'#380' 60 km');
      WebComboBox4.Items.Add('Nie korzystam z komunikacji miejskiej');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox3.SetParentComponent(Self);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 341;
    WebComboBox3.Top := 168;
    WebComboBox3.Width := 347;
    WebComboBox3.Height := 21;
    WebComboBox3.HeightPercent := 100.000000000000000000;
    WebComboBox3.Text := 'Ponad 12 litr'#243'w (32 kWh) / 100 km';
    WebComboBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox3, Self, 'OnClick', 'WebComboBox3Click');
    WebComboBox3.ItemIndex := 0;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('Ponad 12 litr'#243'w (32 kWh) / 100 km');
      WebComboBox3.Items.Add('9 - 12 litr'#243'w (28 kWh) / 100 km');
      WebComboBox3.Items.Add('6 - 9 litr'#243'w (20 kWh) / 100 km');
      WebComboBox3.Items.Add('4,5 - 6 litr'#243'w (14 kWh) / 100 km');
      WebComboBox3.Items.Add('Mniej ni'#380' 4,5 litra (12 kWh) / 100 km');
      WebComboBox3.Items.Add('Nie wiem');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 341;
    WebComboBox2.Top := 129;
    WebComboBox2.Width := 347;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Benzyna / Diesel / Hybryda';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnClick', 'WebComboBox2Click');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Benzyna / Diesel / Hybryda');
      WebComboBox2.Items.Add('Gaz ziemny');
      WebComboBox2.Items.Add('Elektryczny');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 341;
    WebComboBox1.Top := 92;
    WebComboBox1.Width := 347;
    WebComboBox1.Height := 21;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := 'Ponad 30 000 km';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnClick', 'WebComboBox1Click');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Ponad 30 000 km');
      WebComboBox1.Items.Add('14 000 - 30 000 km');
      WebComboBox1.Items.Add('9000 - 14 000 km');
      WebComboBox1.Items.Add('2000 - 9000 km');
      WebComboBox1.Items.Add('Mniej ni'#380' 2000 km');
      WebComboBox1.Items.Add('Nigdy nie je'#380'd'#380#281' samochodem ani motocyklem');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 280;
    WebEdit6.Top := 92;
    WebEdit6.Width := 38;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 30;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 280;
    WebEdit7.Top := 129;
    WebEdit7.Width := 38;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 30;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 281;
    WebEdit12.Top := 165;
    WebEdit12.Width := 38;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 30;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.Text := '0';
    WebEdit12.Visible := False;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 280;
    WebEdit13.Top := 209;
    WebEdit13.Width := 38;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 30;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.Text := '0';
    WebEdit13.Visible := False;
    WebEdit13.WidthPercent := 100.000000000000000000;
  finally
    WebLabel26.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    Transport.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebCheckBox6.AfterLoadDFMValues;
    WebCheckBox4.AfterLoadDFMValues;
    WebCheckBox2.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
  end;
end;

end.
